import { AfterViewInit, Component, Input } from "@angular/core";
import { BooleanAttribute } from "@hex/angular/decorators";
import { BehaviorSubject ,  Subject } from "rxjs";

@Component({
    selector: "common-field-toggle-control",
    templateUrl: "./toggle-control.component.html",
})
export class ToggleControlComponent implements AfterViewInit {
    @Input() public toggleLabel: string;
    @Input() public toggleFieldProp: string;
    @Input() public toggleFieldType: "checkboxSwitch" | "switch" = "checkboxSwitch";
    @Input() public toggleFieldDefault = false;
    @Input() public duplicate = false;
    @Input() @BooleanAttribute() public toggleIsFormField = false;
    @Input() public onLabel = "Yes";
    @Input() public offLabel = "No";

    public disableToggle = false;
    public toggleState = false;

    public toggleState$ = new BehaviorSubject(this.toggleState);
    public toggleTouched$ = new Subject();
    public toggleTouched = false;

    ngAfterViewInit(): void {
        if (this.toggleFieldDefault) {
            this.onToggleStateChange(true)
        }
    }

    public onToggleStateChange(state: boolean): void {
        this.toggleState = state;
        this.toggleState$.next(state);
    }

    public onClick(e): void {
        e.stopPropagation();
        this.toggleTouched$.next();
    }

    public get isCheckbox(): boolean {
        return this.toggleFieldType === "checkboxSwitch";
    }

    public get isSwitch(): boolean {
        return this.toggleFieldType === "switch";
    }

}
